import { FC, ReactNode } from 'react';
import { Wrapper } from './styles';

type Props = {
  children: ReactNode;
};

const ClientRegister: FC<Props> = ({ children }) => (
  <Wrapper titlePage="Cadastrar Cliente" hiddenBorder offPaddingContent>
    {children}
  </Wrapper>
);

export default ClientRegister;
